import { affiliateMerchants } from "../../settings/affiliate";
import namedRoutes from "../../settings/routes";
import {
  BrandPowerStations,
  PowerStation,
  PowerStationInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

//TODO: Exclude old items from EcoFlow vanlife page

/* Missing:
  - STREAM Microinverter    https://us.ecoflow.com/products/stream-microinverter?variant=54376088010825
  - OCEAN Pro               https://energy.ecoflow.com/us/products/ocean-pro-home-solar-battery
  - DELTA 3 2000 Air
*/

// export type EcoFlowSeries =
//   | "DELTA"
//   | "DELTA 2"
//   | "DELTA 3"
//   | "DELTA Pro"
//   | "DELTA Pro 3"
//   | "DELTA Pro Ulta"
//   | "RIVER"
//   | "Power Kit";
// interface EcoFlowPowerStationInternal extends PowerStationInternal {
//   series?: EcoFlowSeries;
// }
// interface EcoFlowPowerStation extends PowerStation {
//   series?: EcoFlowSeries;
// }

const notes = {
  "Smart Generator Adapter": {
    text: "Requires {Smart Generator Adapter}.",
    links: {
      "Smart Generator Adapter": {
        href: "https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393",
        affiliateData: affiliateMerchants.ecoflow,
      },
    },
  },
  "Smart Generator Adapter + Extra Battery Cable": {
    text: "Requires {Smart Generator Adapter} and {Extra Battery Cable}.",
    links: {
      "Smart Generator Adapter": {
        href: "https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393",
        affiliateData: affiliateMerchants.ecoflow,
      },
      "Extra Battery Cable": {
        href: "https://us.ecoflow.com/products/extra-battery-cable",
        affiliateData: affiliateMerchants.ecoflow,
      },
    },
  },
  "Extra Battery Expansion Adapter": {
    text: "Requires {Extra Battery Expansion Adapter} to connect 2nd battery.",
    links: {
      "Extra Battery Expansion Adapter": {
        href: "https://us.ecoflow.com/products/ecoflow-extra-battery-expansion-adapter?variant=55507615645769",
        affiliateData: affiliateMerchants.ecoflow,
      },
    },
  },
  "Power Dock Expansion Limit": {
    text: "Requires 1-3 {Power Dock} accessories to connect more than 3 batteries.",
    links: {
      "Power Dock": {
        href: "https://us.ecoflow.com/products/power-dock?variant=41830215024713",
        affiliateData: affiliateMerchants.ecoflow,
      },
    },
  },
  "Power Dock": {
    text: "Requires {Power Dock accessory}.",
    links: {
      "Power Dock accessory": {
        href: "https://us.ecoflow.com/products/power-dock?variant=41830215024713",
        affiliateData: affiliateMerchants.ecoflow,
      },
    },
  },
  "Power Dock + Smart Generator Adapter": {
    text: "Requires {Power Dock accessory} and {Smart Generator Adapter}.",
    links: {
      "Power Dock accessory": {
        href: "https://us.ecoflow.com/products/power-dock?variant=41830215024713",
        affiliateData: affiliateMerchants.ecoflow,
      },
      "Smart Generator Adapter": {
        href: "https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393",
        affiliateData: affiliateMerchants.ecoflow,
      },
    },
  },
  "Not Officially Supported":
    "May work, not officially supported, attempt at your own risk.",
};

const brand = "EcoFlow";
const rawData: PowerStationInternal[] = [
  // No DC
  {
    name: "TITAN 5000 Classic",
    link: {
      href: "https://us.ecoflow.com/products/ecoflow-titan-5000-classic?variant=55882168991817",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/titan/titan-5000-classic/front.webp",

    price: 2499,
    capacity: 5017.6,
    acOutput: 4000,
    dcOutput: 0,
    solar: 3200,

    expandable: true,
    expansion: {
      portType: "TITAN",
      maxExtraBatteries: 5,
      compatibleBatteries: [
        {
          name: "TITAN Series Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },
  {
    name: "TITAN 5000",
    link: {
      href: "https://us.ecoflow.com/products/ecoflow-titan-5000?variant=55882157654089",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0HN1MNNH3/",
      affiliate: "https://link.amazon/B0aMMfyiL",
    },
    img: "/images/products/ecoflow/titan/titan-5000/front.webp",

    price: 3199,
    capacity: 5017.6,
    acOutput: 7200,
    dcOutput: 0,
    solar: 4000,

    expandable: true,
    expansion: {
      portType: "TITAN",
      maxExtraBatteries: 5,
      compatibleBatteries: [
        {
          name: "TITAN Series Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },
  {
    name: "TITAN 5000 Plus",
    link: {
      href: "https://us.ecoflow.com/products/ecoflow-titan-5000-plus?variant=55882164961353",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0HN1WCQNZ/",
      affiliate: "https://link.amazon/B0gjjJIOs",
    },
    img: "/images/products/ecoflow/titan/titan-5000-plus/front.webp",

    price: 3699,
    capacity: 5017.6,
    acOutput: 7200,
    dcOutput: 0,
    solar: 4000,
    solar2: 4000,

    captions: {
      acOutput:
        "TITAN 5000 Plus AC output can increase to 10,000W when combined with solar.",
    },

    expandable: true,
    expansion: {
      portType: "TITAN",
      maxExtraBatteries: 5,
      compatibleBatteries: [
        {
          name: "TITAN Series Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },

  {
    name: "DELTA 3800 Gen4",
    link: {
      href: "https://us.ecoflow.com/products/delta-3800-gen4?variant=67641627803721",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0HLVRNZDC/",
      affiliate: "https://link.amazon/B04WTtD8E",
    },
    img: "/images/products/ecoflow/delta-4/delta-3800-gen4/front-right.webp",

    price: 2199,
    capacity: 3763,
    acOutput: 3600,
    dcOutput: 0,
    solar: 1000,
    solar2: 1000,

    expandable: true,
    expansion: {
      portType: "4+8",
      maxExtraBatteries: 2,
      notes: [notes["Extra Battery Expansion Adapter"]],
      compatibleBatteries: [
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },
  {
    name: "DELTA 3000 Gen4",
    link: {
      href: "https://us.ecoflow.com/products/delta-3000-gen4?variant=67651080061001",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0HLSH5GWK/",
      affiliate: "https://link.amazon/B0dmUhkW5",
    },
    img: "/images/products/ecoflow/delta-4/delta-3800-gen4/front-right.webp",

    price: 1699,
    capacity: 3072,
    acOutput: 3600,
    dcOutput: 0,
    solar: 1000,

    expandable: false,
  },

  {
    name: "DELTA Pro Ultra X",
    link: {
      href: "https://us.ecoflow.com/products/delta-pro-ultra-x?variant=54714781171785",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FVLPG335/",
      affiliate: "https://amzn.to/4tpLUcX",
    },
    img: "/images/products/ecoflow/delta-pro-ultra-x/front-right.webp",

    price: 7899,
    capacity: 12288,
    acOutput: 12000,
    dcOutput: 0,
    solar: 5000,
    solar2: 5000,

    expandable: true,
    expansion: {
      portType: "5+8",
      maxExtraBatteries: 10,
      notes: [
        "Scalable up to 30 batteries (10 per inverter across 3 inverters) using a Smart Home Panel.",
      ],
      compatibleBatteries: [
        {
          name: "DELTA Pro Ultra Series Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },
  {
    name: "DELTA 3 Classic",
    link: {
      href: "https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FQVC4RF5/",
      affiliate: "https://amzn.to/4sNVllf",
    },
    img: "/images/products/ecoflow/delta-3-classic/front-right.webp",

    price: 439,
    capacity: 1024,
    acOutput: 1800,
    dcOutput: 0,
    solar: 500,

    expandable: false,
  },
  {
    name: "DELTA 3 1000 Air",
    review: namedRoutes.ecoflow.d3air,
    link: {
      href: "https://us.ecoflow.com/products/delta-3-1000-air-10ms-ups-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0G15GWNZQ/",
      affiliate: "https://amzn.to/45gpfWv",
    },
    img: "/images/products/ecoflow/delta-3-1000-air/front-right.webp",

    price: 309,
    capacity: 960,
    acOutput: 500,
    dcOutput: 0,
    solar: 500,

    expandable: false,
  },

  // Low DC
  {
    name: "DELTA 3 Ultra",
    review: namedRoutes.ecoflow.d3ultraPlus,
    link: {
      href: "https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692148871241&view=d3u",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0G1BS3HGZ/",
      affiliate: "https://amzn.to/4dVj8vT",
    },
    img: "/images/products/ecoflow/delta-3-ultra/front-right.webp",

    price: 1369,
    capacity: 3072,
    acOutput: 3600,
    dcOutput: 10,
    solar: 800,

    expandable: false,

    displayPowerSystemsPage: true,
  },
  {
    name: "DELTA 3 Max",
    review: namedRoutes.ecoflow.d3maxPlus,
    link: {
      href: "https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873&view=d3m",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FQV6LMVX/",
      affiliate: "https://amzn.to/3Qe0uW3",
    },
    img: "/images/products/ecoflow/delta-3-max/front-right.webp",

    price: 879,
    capacity: 2048,
    acOutput: 2400,
    dcOutput: 10,
    solar: 500,

    expandable: false,

    displayPowerSystemsPage: true,
  },
  {
    name: "DELTA 2",
    link: {
      href: "https://us.ecoflow.com/products/delta-2-portable-power-station?variant=41719074324553",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0B9XB57XM/",
      affiliate: "https://amzn.to/4cKMITv",
    },
    img: "/images/products/ecoflow/delta-2/front-right.webp",

    price: 599,
    capacity: 1024,
    acOutput: 1800,
    dcOutput: 10,
    solar: 500,

    expandable: true,
    expansion: {
      portType: "XT150",
      maxExtraBatteries: 1,
      compatibleBatteries: [
        { name: "DELTA 2 Smart Extra Battery", type: "direct", official: true },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.reddit.com/r/Ecoflow_community/comments/1vc21rh/comment/p0z126j/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button
          notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.linspyre.com/ecoholics/eb.html
          notes: [
            notes["Not Officially Supported"],
            notes["Smart Generator Adapter + Extra Battery Cable"],
          ],
        },
        { name: "DELTA Max Extra Battery", type: "direct", official: true },
      ],
    },

    displayPowerSystemsPage: true,
  },

  {
    name: "DELTA 3 Plus",
    link: {
      href: "https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826182496329",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DCC2BVFW/",
      affiliate: "https://amzn.to/48Gs8Bq",
    },
    img: "/images/products/ecoflow/delta-3-plus/front-right.webp",

    price: 719,
    capacity: 1024,
    acOutput: 1800,
    dcOutput: 10,
    solar: 500,
    solar2: 500,

    expandable: true,
    expansion: {
      portType: "XT150",
      maxExtraBatteries: 1,
      compatibleBatteries: [
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.linspyre.com/ecoholics/eb.html
          notes: [
            notes["Not Officially Supported"],
            notes["Smart Generator Adapter + Extra Battery Cable"],
          ],
        },
        { name: "DELTA 2 Smart Extra Battery", type: "direct", official: true },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Max Extra Battery",
          type: "direct",
          official: false, // Delta 3 shows as compatible:	https://eu.ecoflow.com/cdn/shop/files/pc__Compatibility_eu_ba6133cc-038d-4ba1-b42d-f19e37db2c26.png?v=1760088527
          notes: [notes["Not Officially Supported"]],
        },
      ],
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "DELTA 3",
    link: {
      href: "https://us.ecoflow.com/products/delta-3-portable-power-station?variant=42015827492937",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DCBYMC9D/",
      affiliate: "https://amzn.to/4tH7cTz",
    },
    img: "/images/products/ecoflow/delta-3/front-right.webp",

    price: 549,
    capacity: 1024,
    acOutput: 1800,
    dcOutput: 10,
    solar: 500,

    expandable: true,
    expansion: {
      portType: "XT150",
      maxExtraBatteries: 1,
      compatibleBatteries: [
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.linspyre.com/ecoholics/eb.html
          notes: [
            notes["Not Officially Supported"],
            notes["Smart Generator Adapter + Extra Battery Cable"],
          ],
        },
        { name: "DELTA 2 Smart Extra Battery", type: "direct", official: true },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Max Extra Battery",
          type: "direct",
          official: false, // Shows as compatible:	https://eu.ecoflow.com/cdn/shop/files/pc__Compatibility_eu_ba6133cc-038d-4ba1-b42d-f19e37db2c26.png?v=1760088527
          notes: [notes["Not Officially Supported"]],
        },
      ],
    },
  },
  {
    name: "DELTA 3 1500",
    link: {
      href: "https://us.ecoflow.com/products/ecoflow-delta-3-1500-solar-generator?variant=41836889014345",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DFY9VZSX",
      affiliate: "https://amzn.to/4hzzrA3",
    },
    img: "/images/products/ecoflow/delta-3-1500/front-right.webp",

    price: 799,
    capacity: 1536,
    acOutput: 1800,
    dcOutput: 10,
    solar: 500,

    expandable: true,
    expansion: {
      portType: "XT150",
      maxExtraBatteries: 1,
      compatibleBatteries: [
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        },
        // {
        //   name: "DELTA 3 Max Plus Smart Extra Battery",
        //   type: "adapter",
        //   notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        // },
        // {
        //   name: "DELTA Pro Smart Extra Battery",
        //   type: "adapter",
        //   notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        // },
        { name: "DELTA 2 Smart Extra Battery", type: "direct", official: true },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Max Extra Battery",
          type: "direct",
          official: false, // Shows as compatible:	https://eu.ecoflow.com/cdn/shop/files/pc__Compatibility_eu_ba6133cc-038d-4ba1-b42d-f19e37db2c26.png?v=1760088527
          notes: [notes["Not Officially Supported"]],
        },
      ],
    },
  },
  {
    name: "DELTA 2 Max",
    link: {
      href: "https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=54615943512137",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0C4DW17PD/",
      affiliate: "https://amzn.to/3QlgQwk",
    },
    img: "/images/products/ecoflow/delta-2-max/front-right.webp",

    price: 899,
    capacity: 2048,
    acOutput: 2400,
    dcOutput: 10,
    solar: 1000,

    expandable: true,
    expansion: {
      portType: "XT150",
      maxExtraBatteries: 2,
      compatibleBatteries: [
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "adapter",
          official: true, // Confirmed via email cannot find source. TODO: Find official source
          notes: [notes["Smart Generator Adapter + Extra Battery Cable"]],
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.linspyre.com/ecoholics/eb.html
          notes: [
            notes["Not Officially Supported"],
            notes["Smart Generator Adapter + Extra Battery Cable"],
          ],
        },
        { name: "DELTA Max Extra Battery", type: "direct", official: true },
      ],
    },
  },

  {
    name: "DELTA Mini",
    link: {
      href: "https://us.ecoflow.com/products/delta-mini-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/delta-mini/front-right.webp",

    price: 549,
    capacity: 882,
    acOutput: 1400,
    dcOutput: 10,
    solar: 300,

    expandable: false,
    discontinued: true,
  },
  {
    name: "DELTA (1000)",
    link: {
      href: "https://us.ecoflow.com/products/delta-portable-power-station?variant=39438995488841",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/delta/front-right.webp",

    capacity: 1008,
    acOutput: 1600,
    dcOutput: 8,
    solar: 400,

    expandable: false,
    discontinued: true,
  },
  {
    name: "DELTA (1300)",
    link: {
      href: "https://us.ecoflow.com/products/delta-portable-power-station?variant=39438995456073",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/delta/front-right.webp",

    capacity: 1260,
    acOutput: 1800,
    dcOutput: 8,
    solar: 400,

    expandable: false,
    discontinued: true,
  },

  {
    name: "DELTA Max (1600)",
    link: {
      href: "https://www.ecoflow.com/us/delta-max-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/delta-max/front-right.webp",

    capacity: 1612,
    acOutput: 2000,
    dcOutput: 10,
    solar: 800,

    expandable: true,
    expansion: {
      portType: "XT150",
      maxExtraBatteries: 2,
      compatibleBatteries: [
        {
          name: "DELTA Max Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
    discontinued: true,
  },
  {
    name: "DELTA Max (2000)",
    link: {
      href: "https://www.ecoflow.com/us/delta-max-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/delta-max/front-right.webp",

    capacity: 2016,
    acOutput: 2400,
    dcOutput: 10,
    solar: 800,

    expandable: true,
    expansion: {
      portType: "XT150",
      maxExtraBatteries: 2,
      compatibleBatteries: [
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Max Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
    discontinued: true,
  },

  // RIVER
  // {
  //   name: "RIVER 3 Max Plus Wireless",
  //   link: {
  //     href: "https://us.ecoflow.com/collections/river-series/products/river-3-max-plus-wireless",
  //     affiliateData: affiliateMerchants.ecoflow,
  //     icon: "EcoFlow",
  //   },
  //   amazon: {
  //     href: "",
  //     affiliate: "",
  //   },
  //   img: "/images/products/ecoflow/river/river-3-max-plus-wireless/front-right.webp",

  //   price: 858,
  //   capacity: 0,
  //   acOutput: 600,
  //   dcOutput: 10,
  //   solar: 0,
  //   expandable: true,
  // },
  {
    name: "RIVER 3 Plus Wireless",
    link: {
      href: "https://us.ecoflow.com/products/river-3-plus-wireless",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/ecoflow/river/river-3-plus-wireless/front-right.webp",

    price: 409,
    capacity: 286,
    acOutput: 600,
    dcOutput: 10,
    solar: 220,

    expandable: true,
    expansion: {
      portType: "Pogo Pin",
      maxExtraBatteries: 1,
      compatibleBatteries: [
        {
          name: "RIVER 3 Plus EB300 Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "RIVER 3 Plus EB600 Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },
  {
    name: "RIVER 3 Plus",
    link: {
      href: "https://us.ecoflow.com/products/river-3-plus-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DCCB657J/",
      affiliate: "https://amzn.to/41PFJ5E",
    },
    img: "/images/products/ecoflow/river/river-3-plus/front-right.webp",

    price: 259,
    capacity: 286,
    acOutput: 600,
    dcOutput: 10,
    solar: 220,

    expandable: true,
    expansion: {
      portType: "Pogo Pin",
      maxExtraBatteries: 1,
      compatibleBatteries: [
        {
          name: "RIVER 3 Plus EB300 Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "RIVER 3 Plus EB600 Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },
  {
    name: "RIVER 3 (230)",
    link: {
      href: "https://us.ecoflow.com/products/river-3-230-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/ecoflow/river/river-3-230/front-right.webp",

    price: 229,
    capacity: 230,
    acOutput: 300,
    dcOutput: 10,
    solar: 110,

    expandable: false,
  },
  {
    name: "RIVER 3",
    link: {
      href: "https://us.ecoflow.com/collections/river-series/products/river-3-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DB1S36YP/",
      affiliate: "https://amzn.to/4u3kcm8",
    },
    img: "/images/products/ecoflow/river/river-3/front-right.webp",

    price: 199,
    capacity: 245,
    acOutput: 300,
    dcOutput: 10,
    solar: 110,

    expandable: false,
  },
  {
    name: "RIVER 2 Pro (700)",
    link: {
      href: "https://us.ecoflow.com/products/river-2-pro-700-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0GWQVZD9F/",
      affiliate: "https://amzn.to/3OFLmjI",
    },
    img: "/images/products/ecoflow/river/river-2-pro-700/front-right.webp",

    price: 329,
    capacity: 716,
    acOutput: 800,
    dcOutput: 10,
    solar: 220,

    expandable: false,
  },
  {
    name: "RIVER 2 Pro",
    link: {
      href: "https://us.ecoflow.com/products/river-2-pro-portable-power-station?variant=54320636198985",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0BVLPGS79/",
      affiliate: "https://amzn.to/3OuEYvQ",
    },
    img: "/images/products/ecoflow/river/river-2-pro/front-right.webp",

    price: 349,
    capacity: 768,
    acOutput: 800,
    dcOutput: 10,
    solar: 220,

    expandable: false,
  },
  {
    name: "RIVER 2 Max",
    link: {
      href: "https://us.ecoflow.com/products/river-2-max-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0B97H2XHS/",
      affiliate: "https://amzn.to/3OzLoJW",
    },
    img: "/images/products/ecoflow/river/river-2-max/front-right.webp",

    price: 289,
    capacity: 512,
    acOutput: 500,
    dcOutput: 10,
    solar: 220,

    expandable: false,
  },
  {
    name: "RIVER 2 (240)",
    link: {
      href: "https://us.ecoflow.com/products/river-2-240-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/ecoflow/river/river-2-240/front-right.webp",

    price: 219,
    capacity: 243,
    acOutput: 300,
    dcOutput: 8,
    solar: 110,

    expandable: false,
  },
  {
    name: "RIVER 2",
    link: {
      href: "https://us.ecoflow.com/products/river-2-portable-power-station",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0B8MXPRDB/",
      affiliate: "https://amzn.to/4covPhA",
    },
    img: "/images/products/ecoflow/river/river-2/front-right.webp",

    price: 189,
    capacity: 256,
    acOutput: 300,
    dcOutput: 8,
    solar: 110,

    expandable: false,
  },
  {
    name: "RIVER Pro",
    link: {
      href: "https://us.ecoflow.com/products/river-pro-river-pro-extra-battery-bundle?variant=31919899050057",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/river/river-pro/front-right.webp",

    //price: null,
    capacity: 720,
    acOutput: 600,
    dcOutput: 10,
    solar: 200,

    expandable: true,
    expansion: {
      portType: "D-Sub 7W2",
      maxExtraBatteries: 1,
      compatibleBatteries: [
        {
          name: "RIVER Pro Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
    discontinued: true,
  },

  // High DC
  {
    name: "DELTA Pro 3",
    review: namedRoutes.ecoflow.dp3,
    link: {
      href: "https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0D14FMFZD/",
      affiliate: "https://amzn.to/3MkrPnm",
    },
    img: "/images/products/ecoflow/delta-pro-3/front-right.webp",

    price: 2799,
    capacity: 4096,
    acOutput: 4000,
    dcOutput: 30,
    solar: 1600,
    solar2: 1000,

    expandable: true,
    expansion: {
      portType: "4+8",
      maxExtraBatteries: 2,
      notes: [
        "Scalable up to 36.9kWh across 3 power stations and 6 batteries using a Smart Home Panel.",
      ],
      compatibleBatteries: [
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "DELTA Pro",
    review: namedRoutes.ecoflow.dp,
    link: {
      href: "https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0C1Z4GLKS/",
      affiliate: "https://amzn.to/4oJeF0L",
    },
    img: "/images/products/ecoflow/delta-pro/front-right.webp",

    price: 1899,
    capacity: 3600,
    acOutput: 3600,
    dcOutput: 30,
    solar: 1600,
    solar2: 0,

    expandable: true,
    expansion: {
      portType: "4+8",
      maxExtraBatteries: 2,
      notes: [
        "Scalable up to 21.6kWh across 2 power stations and 4 batteries using a Hub or Smart Home Panel.",
      ],
      compatibleBatteries: [
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "DELTA 3 Ultra Plus",
    review: namedRoutes.ecoflow.d3ultraPlus,
    link: {
      href: "https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713&view=d3u",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FQVG59LV/",
      affiliate: "https://amzn.to/4svqHOK",
    },
    img: "/images/products/ecoflow/delta-3-ultra-plus/front-right.webp",

    price: 1599,
    capacity: 3072,
    acOutput: 3600,
    dcOutput: 30,
    solar: 800,
    solar2: 800,

    expandable: true,
    expansion: {
      portType: "4+8",
      maxExtraBatteries: 2,
      notes: [notes["Extra Battery Expansion Adapter"]],
      compatibleBatteries: [
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "DELTA 3 Max Plus",
    review: namedRoutes.ecoflow.d3maxPlus,
    link: {
      href: "https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441&view=d3m",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FQV9Q9J2/",
      affiliate: "https://amzn.to/4qhlyYI",
    },
    img: "/images/products/ecoflow/delta-3-max-plus/front-right.webp",

    price: 1149,
    capacity: 2048,
    acOutput: 3000,
    dcOutput: 30,
    solar: 500,
    solar2: 500,

    expandable: true,
    expansion: {
      portType: "4+8",
      maxExtraBatteries: 2,
      notes: [notes["Extra Battery Expansion Adapter"]],
      compatibleBatteries: [
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "direct",
          official: true,
        },
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Smart Generator Adapter"]],
        },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Smart Generator Adapter"]],
        },
      ],
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "DELTA Pro Ultra",
    link: {
      href: "https://us.ecoflow.com/products/delta-pro-ultra?variant=40758830071881",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0CQXMZ5BK/",
      affiliate: "https://amzn.to/4jmSTyU",
    },
    img: "/images/products/ecoflow/delta-pro-ultra/front-right.webp",

    price: 3999,
    capacity: 6144,
    acOutput: 7200,
    dcOutput: 30,
    solar: 4000,
    solar2: 1600,

    expandable: true,
    expansion: {
      portType: "5+8",
      maxExtraBatteries: 5,
      notes: [
        "Scalable up to 15 batteries (5 per inverter across 3 inverters) using a Smart Home Panel.",
      ],
      compatibleBatteries: [
        {
          name: "DELTA Pro Ultra Series Smart Extra Battery",
          type: "direct",
          official: true,
        },
      ],
    },
  },

  // Modular
  {
    name: "Power Kits 3.6kW (Gen 1)",
    link: {
      href: "https://us.ecoflow.com/products/5kwh-power-kits?variant=39946322313289",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/power-kit/gen-1.webp",

    price: 8699,
    capacity: 0,
    capacityMin: 2048,
    capacityMax: 46080,
    acOutput: 3600,
    dcOutput: 70,
    solar: 1600,
    solar2: 1600,
    solar3: 1600,

    expandable: true,
    modular: true,
    expansion: {
      portType: "PowerKit",
      maxExtraBatteries: 9,
      notes: [notes["Power Dock Expansion Limit"]],
      compatibleBatteries: [
        { name: "5kWh LFP Battery", type: "direct", official: true },
        { name: "2kWh LFP Battery", type: "direct", official: true },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock"]],
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock"]],
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "adapter",
          official: false, // Really???
          notes: [notes["Not Officially Supported"], notes["Power Dock"]],
        },
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.linspyre.com/ecoholics/eb.html
          notes: [
            notes["Not Officially Supported"],
            notes["Power Dock + Smart Generator Adapter"],
          ],
        },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock + Smart Generator Adapter"]],
        },
        {
          name: "DELTA 2 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock + Smart Generator Adapter"]],
        },
      ],
    },

    captions: {
      dcOutput:
        "Circuits 1–2 provide up to 30A each, while Circuits 3–6 provide up to 20A each.",
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "Power Kits 5kVA (Gen 2) 70A",
    link: {
      href: "https://us.ecoflow.com/products/power-kits-5kva-48v-power-system?variant=41830211682377",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/power-kit/5kva-30a.webp",

    price: 8246,
    capacity: 0,
    capacityMin: 2048,
    capacityMax: 46080,
    acOutput: 4000,
    dcOutput: 70,
    solar: 4000,
    solar2: 1600,
    solar3: 1600,

    expandable: true,
    modular: true,
    expansion: {
      portType: "PowerKit",
      maxExtraBatteries: 9,
      notes: [notes["Power Dock Expansion Limit"]],
      compatibleBatteries: [
        { name: "5kWh LFP Battery", type: "direct", official: true },
        { name: "2kWh LFP Battery", type: "direct", official: true },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock"]],
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock"]],
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "adapter",
          official: false, // Really???
          notes: [notes["Not Officially Supported"], notes["Power Dock"]],
        },
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.linspyre.com/ecoholics/eb.html
          notes: [
            notes["Not Officially Supported"],
            notes["Power Dock + Smart Generator Adapter"],
          ],
        },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock + Smart Generator Adapter"]],
        },
        {
          name: "DELTA 2 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock + Smart Generator Adapter"]],
        },
      ],
    },

    captions: {
      dcOutput:
        "Circuits 1–2 provide up to 30A each, while Circuits 3–6 provide up to 20A each.",
    },

    displayPowerSystemsPage: true,
  },
  {
    name: "Power Kits 5kVA (Gen 2) 100A",
    link: {
      href: "https://us.ecoflow.com/products/power-kits-5kva-48v-power-system?variant=41830211715145",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/power-kit/5kva-50a.webp",

    price: 8296,
    capacity: 0,
    capacityMin: 2048,
    capacityMax: 46080,
    acOutput: 4000,
    dcOutput: 100,
    solar: 4000,
    solar2: 1600,
    solar3: 1600,

    expandable: true,
    modular: true,
    expansion: {
      portType: "PowerKit",
      maxExtraBatteries: 9,
      notes: [notes["Power Dock Expansion Limit"]],
      compatibleBatteries: [
        { name: "5kWh LFP Battery", type: "direct", official: true },
        { name: "2kWh LFP Battery", type: "direct", official: true },
        {
          name: "DELTA Pro 3 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock"]],
        },
        {
          name: "DELTA Pro Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock"]],
        },
        {
          name: "DELTA 3 Max Plus Smart Extra Battery",
          type: "adapter",
          official: false, // Really???
          notes: [notes["Not Officially Supported"], notes["Power Dock"]],
        },
        {
          name: "DELTA 3 Series Smart Extra Battery",
          type: "adapter",
          official: false, // Use at own risk: https://www.linspyre.com/ecoholics/eb.html
          notes: [
            notes["Not Officially Supported"],
            notes["Power Dock + Smart Generator Adapter"],
          ],
        },
        {
          name: "DELTA 2 Max Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock + Smart Generator Adapter"]],
        },
        {
          name: "DELTA 2 Smart Extra Battery",
          type: "adapter",
          official: true,
          notes: [notes["Power Dock + Smart Generator Adapter"]],
        },
      ],
    },

    captions: {
      dcOutput:
        "Circuits 1–13 provide up to 30A each, while Circuits 14–16 provide up to 50A each.",
    },

    displayPowerSystemsPage: true,
  },
];

const powerStations: BrandPowerStations = {
  name: brand,
  powerStations: buildProductRecord<PowerStationInternal, PowerStation>(
    rawData,
    brand
  ),
};

export default powerStations;
